/** @format */

import React, { useState } from 'react'
import Checkbox from '../../../../Components/Checkbox/Checkbox'
import Loader from '../../../../Components/Loaders/Loader'
import ModalTemplate from '../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../Global/Localize'
import { showNotification } from '../../../../Helpers/Notification/ShowNotification'
import { postData, putData } from '../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../Validation/ValidationState'

const ExitInterviewQuestionModal = ({
  mode,
  selectedExitInterviewQuestion,
  setSelectedExitInterviewQuestion,
  closeModal,
  loadTableData,
}) => {
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()
  const [isBusy, setIsBusy] = useState(false)

  function clearValidation(column) {
    setGlobalValidationErrors(validation => {
      delete validation[column]
      return validation
    })
  }
  async function handleSubmit() {
    setIsBusy(true)
    const { success } =
      mode === 'edit'
        ? await putData(
            '/ExitInterviewQuestion/update',
            selectedExitInterviewQuestion || {
              description: '',
            },
            false
          )
        : await postData(
            '/ExitInterviewQuestion/create',
            selectedExitInterviewQuestion || {
              description: '',
            },
            false
          )

    if (success) {
      setIsBusy(false)
      closeModal()
      loadTableData()
      showNotification('Exit Interview Question', 'success')
    }
    setIsBusy(false)
  }

  return (
    <ModalTemplate
      modalClassName="modal-lg"
      modalTitle={'exitInterviewQuestions'}
      modalMode={mode}
      handleAction={handleSubmit}
      handleClose={closeModal}
      actionText={mode === 'add' ? 'create' : 'update'}
      footerChildren={
        <>
          <div className="d-flex align-items-center me-3 gap-2">
            <Checkbox
              id="cExitInterviewQuestionIsLocked"
              onCheck={e => {
                setSelectedExitInterviewQuestion({
                  ...selectedExitInterviewQuestion,
                  isLocked: e,
                })
              }}
              checked={selectedExitInterviewQuestion?.isLocked}
            />
            <label
              htmlFor="cExitInterviewQuestionIsLocked"
              className="text-capitalize"
            >
              {localize('isLocked')}?
            </label>
          </div>
        </>
      }
    >
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row mb-3 g-3">
            <div className="col-md-12">
              <div
                className="with-validation d-flex align-items-center mb-2"
                validation-message={
                  globalValidationErrors['Description']?.message
                }
              >
                <label className="text-capitalize col-1">
                  {localize('question')}
                </label>
                <input
                  defaultValue={selectedExitInterviewQuestion?.description}
                  type="text"
                  className="form-control"
                  onChange={e => {
                    clearValidation('Description')
                    setSelectedExitInterviewQuestion({
                      ...selectedExitInterviewQuestion,
                      description: e.target.value,
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </ModalTemplate>
  )
}

export default ExitInterviewQuestionModal
